import { ProjectLastUsedDto } from '../../../api/api-types';

export const getFilteredEmployeeData = (
  employeeData: ProjectLastUsedDto,
  projectName: string,
) =>
  employeeData.projectDTOList.find(
    (eachEmployeeData) => eachEmployeeData?.name === projectName,
  );
